import type { Interpolation } from "@emotion/react";

export const stylesOpacity: Record<string, Interpolation> = {
  active: {
    opacity: 1,
    ":active": { opacity: 0.5 },
  },
  base: {
    transition: "all 150ms ease-out",
  },
};
